import styled from 'styled-components';

export const RequiredStar = styled.span`
  color: ${({ theme }) => theme.colors.danger.main};
`;
